import { Amplify } from "aws-amplify";

interface AdminPublicConfig {
  cognito_user_pool_id: string;
  cognito_client_id: string;
  cognito_region: string;
}

const API_BASE = import.meta.env.VITE_API_BASE_URL ?? "";

/** Fetch public Cognito config from the backend and configure Amplify.
 *
 * The backend exposes /api/admin/config (unauthenticated) returning the
 * public client identifiers from the same .env that drives JWT validation.
 * This means a single source of truth across backend + SPA + k8s secrets,
 * and the SPA bundle stays environment-agnostic.
 */
export async function configureAmplify(): Promise<void> {
  const resp = await fetch(`${API_BASE}/api/admin/config`);
  if (!resp.ok) {
    throw new Error(
      `Failed to load admin config (${resp.status}). Is the backend running?`,
    );
  }
  const cfg = (await resp.json()) as AdminPublicConfig;

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: cfg.cognito_user_pool_id,
        userPoolClientId: cfg.cognito_client_id,
        // @ts-expect-error region is supported but absent from types in some Amplify v6 minors
        region: cfg.cognito_region,
      },
    },
  });
}
